
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiController as ObcPoiControllerElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-controller/poi-controller.js';
 
 
 

 
 export const ObcPoiController = createComponent({
   react: React,
   tagName: 'obc-poi-controller',
   elementClass: ObcPoiControllerElement,
   events: {
     
   }
  });
 
 